/**
 * Progress container animations
 * Entrance animation for the entire progress bar container
 */

import { PROGRESS_CONTAINER_CONSTANTS } from '../constants/progress-container.constants';

export const progressContainerAnimations = {
  '@keyframes progressEntrance': {
    '0%': {
      opacity: PROGRESS_CONTAINER_CONSTANTS.ENTRANCE.INITIAL.OPACITY,
      transform: `translateY(${PROGRESS_CONTAINER_CONSTANTS.ENTRANCE.INITIAL.TRANSLATE_Y})`,
    },
    '100%': {
      opacity: PROGRESS_CONTAINER_CONSTANTS.ENTRANCE.FINAL.OPACITY,
      transform: `translateY(${PROGRESS_CONTAINER_CONSTANTS.ENTRANCE.FINAL.TRANSLATE_Y})`,
    },
  },
};
